var _circle, _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFound404Circled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 135,
    r: 135,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4323 158V108.176H83.5043L62.8643 137.84V133.904H104.528V145.52H51.9203V134.384L83.2163 89.648H95.2163V158H80.4323ZM135.019 158.864C126.763 158.864 120.427 155.888 116.011 149.936C111.659 143.92 109.483 135.184 109.483 123.728C109.483 112.464 111.659 103.856 116.011 97.904C120.427 91.952 126.763 88.976 135.019 88.976C143.275 88.976 149.579 91.952 153.931 97.904C158.347 103.856 160.555 112.464 160.555 123.728C160.555 135.12 158.347 143.824 153.931 149.84C149.579 155.856 143.275 158.864 135.019 158.864ZM135.019 147.344C138.795 147.344 141.547 145.488 143.275 141.776C145.003 138.064 145.867 132.048 145.867 123.728C145.867 115.6 145.003 109.68 143.275 105.968C141.547 102.256 138.795 100.4 135.019 100.4C131.243 100.4 128.491 102.256 126.763 105.968C125.035 109.68 124.171 115.6 124.171 123.728C124.171 132.048 125.035 138.064 126.763 141.776C128.491 145.488 131.243 147.344 135.019 147.344ZM195.557 158V108.176H198.629L177.989 137.84V133.904H219.653V145.52H167.045V134.384L198.341 89.648H210.341V158H195.557Z",
    fill: "#BABABA"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 182,
    width: 196,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 191C37 186.029 41.0294 182 46 182H128C132.971 182 137 186.029 137 191C137 195.971 132.971 200 128 200H46C41.0294 200 37 195.971 37 191Z",
    fill: "#F4B850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 191C133 186.029 137.029 182 142 182H224C228.971 182 233 186.029 233 191C233 195.971 228.971 200 224 200H142C137.029 200 133 195.971 133 191Z",
    fill: "#F4B850"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 182,
    width: 18,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 182,
    width: 4,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 182,
    width: 15,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 182,
    width: 7,
    height: 18,
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 182,
    width: 13,
    height: 18,
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 182,
    width: 13,
    height: 18,
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 182,
    width: 8,
    height: 18,
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 182,
    width: 44,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 182,
    width: 8,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 182,
    width: 4,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 182,
    width: 11,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 182,
    width: 5,
    height: 18,
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 182,
    width: 12,
    height: 18,
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 182,
    width: 5,
    height: 18,
    fill: "#BABABA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 182,
    width: 26,
    height: 18,
    fill: "#484848",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 182,
    width: 4,
    height: 18,
    fill: "#BABABA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound404Circled);
export default __webpack_public_path__ + "static/media/not-found-404-circled.eb61d0a107bd3fb1792ec3a3e29e630a.svg";
export { ForwardRef as ReactComponent };